import {AppDispatch, store} from '@/store'
import {SET_ERROR_MODAL_BY_CATCH} from '@/store/slices/storage'

const dispatch: AppDispatch = store.dispatch

export const errorCodeHandler = (
  e: any,
  list?: {error: number; callback: () => void}[]
) => {
  const payload = e?.response?.data ?? e
  const error = payload?.local_code || e?.response?.status
  const message = payload?.message || 'Unknown error'

  if (e && e.response?.code === 449) {
    return
  }

  if (list) {
    const elementError = list.find((element) => {
      return error === element.error
    })
    if (elementError) {
      elementError.callback()
    }
  } else {
    dispatch(SET_ERROR_MODAL_BY_CATCH({code: error, message}))
  }
}

export const errorTrueCodeHandler = (
  error: number,
  message: string,
  list?: {error: number; callback: () => void}[]
) => {
  if (list) {
    const elementError = list.find((element) => {
      return error === element.error
    })
    if (elementError) {
      elementError.callback()
    }
  } else {
    dispatch(SET_ERROR_MODAL_BY_CATCH({code: error, message}))
  }
}
